import styled from "styled-components";
import { NavLink as Link } from "react-router-dom";
import { FaBars } from "react-icons/fa";

export const Nav = styled.nav`
  background: linear-gradient(
    90deg,
    rgba(238, 109, 152, 1) 15%,
    rgba(138, 94, 191, 1) 85%
  );
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 80px;
  padding: 0.5rem;
  color: #fff;
`;
export const NavLink = styled(Link)`
  color: #fff;
  display: flex; 
  align-items: center;
  text-decoration: none;
  cursor: pointer;
  margin: 10px;
  transition: all 0.1s;
  &:hover {
    transform: scale(1.05);
    color: #fff;
  }
`;
// HamburgerButton display when screen size less than 600px
export const HamburgerButton = styled(FaBars)`
  display: none;
  color: #fff;
  @media screen and (max-width: 600px) {
    display: block;   
    position: absolute;
    top: 0;
    right: 0;
    font-size: 1.8em;
    transform: translate(-100%, 75%);
    cursor: pointer;
  }
`;
// NavMenu-> for displaying insights and placements button when screen size greater than 600px 
export const NavMenu = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  @media screen and (max-width: 600px) {
    display: none;
  }
`;
export const HeadingStyle = styled.span`
  font-family: "Dancing Script", cursive;
`;
// ResponsiveNav-> for displaying home,insights and placements button when screen size less than 600px 
export const ResponsiveNav = styled.div`
  background: linear-gradient(
    90deg,
    rgba(238, 109, 152, 1) 15%,
    rgba(138, 94, 191, 1) 85%
  );
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 10;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  clip-path: circle(0px at 100% 0);
  -webkit-clip-path: circle(00px at 100% 0);
  transition: all 1s ease-out;
  &.open {
    transition: all 1s ease-out;
    clip-path: circle(1100px at 100% 0);
  }
`;
